import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { context as globalContext, setupFetchInterceptor } from './context';
import { Footer } from './Footer';
import { Header } from './Header';
import { WaitingBackdrop } from './WaitingBackdrop';
import { MessageSnackbar } from './MessageSnackbar';
import { ServerMaintenanceDialog } from './ServerMaintenanceDialog';
import { AppMigrationNoticeDialog, getMigrationNoticeShouldShow } from './AppMigrationNoticeDialog';

export const App = () => {

    const [message, setMessage] = React.useState({});
    const [messageStatus, setMessageStatus] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [serverMaintenance, setServerMaintenance] = React.useState(false);
    const [migrationDialogOpen, setMigrationDialogOpen] = React.useState(false);

    const onMessage = (message) => {
        setMessage(message);
        setMessageStatus(true);
    };

    // 设置fetch拦截器来监控服务器连接状态
    React.useEffect(() => {
        setupFetchInterceptor(setServerMaintenance);
    }, []);

    React.useEffect(() => {
        if (getMigrationNoticeShouldShow()) {
            setMigrationDialogOpen(true);
        }
    }, []);

    const value = {
        message,
        messageStatus,
        setMessageStatus,
        setLoading,
        onMessage,
        serverMaintenance,
        setServerMaintenance
    };

    return (
        <globalContext.Provider value={value}>
            <Box sx={{ 
                display: 'flex', 
                width: '100%', 
                minHeight: '100vh',
                flexDirection: 'column',
                bgcolor: 'background.default'
            }}>
                <Header onOpenMigrationNotice={() => setMigrationDialogOpen(true)} />
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <Outlet />
                </Box>
                <Footer />
                <WaitingBackdrop loading={loading}/>
                <MessageSnackbar />
                <ServerMaintenanceDialog />
                <AppMigrationNoticeDialog
                    open={migrationDialogOpen}
                    onClose={() => setMigrationDialogOpen(false)}
                />
            </Box>
        </globalContext.Provider>
    );
}